import { SmsCp } from "../core/api/models";

export class OperatorTypesUiDto {
    type?: SmsCp;
    colorName?: string;
    color?: string;
}

const styles = getComputedStyle(document.documentElement);

export const OperatorTypesUi: OperatorTypesUiDto[] = [
    {
        type: SmsCp.PishgamRayan,
        colorName: "primary",
        color: styles.getPropertyValue('--color-navyBlue'),
    },
    {
        type: SmsCp.Armaghan,
        colorName: "pink-tint",//صورتی
        color: styles.getPropertyValue('--color-pink-tint'),
    },{
        type: SmsCp.Asanak,
        colorName: "orange",//نارنجی
        color: styles.getPropertyValue('--color-orange'),
    },{
        type: SmsCp.Avanak,
        colorName: "teal",//سبزآبی
        color: styles.getPropertyValue('--color-teal'),
    },{
        type: SmsCp.RahyabPG,
        colorName: "success",//سبز
        color: styles.getPropertyValue('--color-success'),
    },{
        type: SmsCp.RahyabRG,
        colorName: "blue-light",//آبی کمرنگ
        color: styles.getPropertyValue('--color-blue-light'),
    },{
        type: SmsCp.Magfa,
        colorName: "info",//بنفش
        color: styles.getPropertyValue('--color-info'),
    },{
        type: SmsCp.SocialNetworks,
        colorName: "slate",//خاکستری
        color: styles.getPropertyValue('--color-slate'),
    },{
        type: SmsCp.SLS,
        colorName: "warning-tint",//زرد
        color: styles.getPropertyValue('--color-warning-tint'),
    },{
        type: SmsCp.Idehgate,
        colorName: "danger-dark",//قرمز تیره
        color: styles.getPropertyValue('--color-danger-dark'),
    },{
        type: SmsCp.Irancell,
        colorName: "warning",//زرد تیره
        color: styles.getPropertyValue('--color-warning'),
    },{
        type: SmsCp.Rightel,
        colorName: "danger",//قرمز
        color: styles.getPropertyValue('--color-danger'),
    },{
        type: SmsCp.MCI,
        colorName: "cyan",//فیروزه ای
        color: styles.getPropertyValue('--color-cyan'),
    },{
        type: SmsCp.PishgamRayan2,
        colorName: "ministry",//آبی نفتی
        color: styles.getPropertyValue('--color-ministry'),
    },{
        type: SmsCp.PishgamRayan3,
        colorName: "blue",//آبی
        color: styles.getPropertyValue('--color-blue'),
    },{
        type: SmsCp.Mxb,
        colorName: "lime",//لیمویی
        color: styles.getPropertyValue('--color-lime'),
    },{
        type: SmsCp.Kando,
        colorName: "orange-dark",//قهوه ای
        color: styles.getPropertyValue('--color-orange-dark'),
    },
    // {
    //     type: SmsCp.SmartX,
    //     colorName: "teal",
    //     color: styles.getPropertyValue('--color-teal'),
    // },
    // {
    //     type: SmsCp.Gama,
    //     colorName: "danger",
    //     color: styles.getPropertyValue('--color-danger'),
    // },
];
